/**
 * Shared helpers for the free-text search + highlight used by the sidebar and
 * the schema table. Both take untrusted user input, so anything that ends up in
 * a RegExp must be escaped first.
 */

/** Escape RegExp metacharacters so user input can be embedded in a pattern. */
export function escapeRegExp(value) {
  return String(value ?? '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Case-insensitive filter of `{ name }` entities. Returns the original array
 * (same identity) when there is no search term so memoized consumers do not
 * re-render on an empty search.
 */
export function filterByName(items, term) {
  if (!Array.isArray(items)) return [];

  const query = String(term ?? '')
    .trim()
    .toLowerCase();
  if (!query) return items;

  return items.filter(
    (item) => typeof item?.name === 'string' && item.name.toLowerCase().includes(query)
  );
}
